import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import { useTranslation } from "@i18n";
import { useParams, useLocation } from "react-router-dom";
import stl from "./FreeFinanceFormPage.module.css";
import TitleSection from "./FreeFinanceComponents/TitleSection";
import FinanceWarrantySection from "@/pages/checkout/warranty/FinanceWarrantySection";
import InfoComponent from "./FreeFinanceComponents/InfoComponent";
import { api__getFinancePostData } from "@/apis/freeFinance/api__getFinancePostData";
import FinanceCarCard from "./FreeFinanceComponents/FinanceCarCard";
import WorkInfoComponent from "./FreeFinanceComponents/WorkInfoComponent";
import UserUploadInfo from "./FreeFinanceComponents/UserUploadInfo";
import Loader3d from "./FreeFinanceComponents/Loader3d";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import api__deleteFinanceOrder from "@/apis/freeFinance/api__deleteFinanceOrder";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import useCookieClient from "@hooks/useCookieClient";
import { api__getWarrantyList } from "@/apis/orders/orders";
var FinanceFormPage = function FinanceFormPage() {
  var _postData$details2, _ref, _checkoutOrder$financ, _checkoutOrder$financ2, _checkoutOrder$financ3, _checkoutOrder$financ4, _checkoutOrder$financ5, _checkoutOrder$financ6;
  if (__IS_SSR__) return null;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var params = useParams();
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var location = useLocation();

  // const queryParams = queryString.parse(location.search);
  var queryParams = new URLSearchParams(location.search);
  var postId = params.id;
  var financestep = queryParams.get("financestep");
  var _useState = useState(false),
    reachUpload = _useState[0],
    setReachUpload = _useState[1];
  var _useState2 = useState(null),
    postData = _useState2[0],
    setPostData = _useState2[1];
  var _useState3 = useState(false),
    isOtpStep = _useState3[0],
    setIsOtpStep = _useState3[1];
  var _useState4 = useState(false),
    loader = _useState4[0],
    setLoader = _useState4[1];
  var _useState5 = useState(false),
    ShowPopUp = _useState5[0],
    setShowPopUp = _useState5[1];
  var _useState6 = useState(null),
    uuID = _useState6[0],
    setUuID = _useState6[1];
  var _useState7 = useState(null),
    mobileNUmberForEvent = _useState7[0],
    setMobileNUmberForEvent = _useState7[1];
  var _useState8 = useState(false),
    hasStartedCheckoutForm = _useState8[0],
    setHasStartedCheckoutForm = _useState8[1];
  var _useState9 = useState(null),
    checkoutOrder = _useState9[0],
    setCheckoutOrder = _useState9[1];
  var _useState0 = useState(null),
    selectedWarrantyId = _useState0[0],
    setSelectedWarrantyId = _useState0[1];
  var _useSession = useSession(),
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var dataInSession = sessionStorage.getItem("installment-calculator-".concat(postId));
  var isFromFinanceCalculator = Boolean(__IS_CSR__ && sessionStorage.getItem("installment-calculator-".concat(postId)));
  var currentStepLabel = !isOtpStep ? +financestep === 1 ? tShort("form/personal_information") : +financestep === 2 ? tShort("form/work_information") : +financestep === 3 ? tShort("form/documents_required") : "" : "";
  useEffect(function () {
    var _JSON$parse;
    var installmentPeriod = (_JSON$parse = JSON.parse(dataInSession)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.period;
    api__getFinancePostData(postId).then(function (res) {
      var _res$data;
      setPostData(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data);
    });
    api__getWarrantyList(_objectSpread({
      post_id: Number(postId)
    }, installmentPeriod ? {
      installment_period: installmentPeriod
    } : {})).then(function (res) {
      setCheckoutOrder(function (prev) {
        return prev ? _objectSpread(_objectSpread({}, prev), res) : res;
      });
    })["catch"](function () {
      return null;
    });
    setUuID(queryParams.get("uuid"));
  }, []);
  useEffect(function () {
    var _postData$details;
    if (postData !== null && postData !== void 0 && (_postData$details = postData.details) !== null && _postData$details !== void 0 && _postData$details.is_eligible_for_arib) {
      navigateTo("/finance-apply-arib", {
        post_id: postId,
        financestep: 1
      });
    }
  }, [postData]);
  useEffect(function () {
    setUuID(queryParams.get("uuid"));
  }, [loader]);
  useEffect(function () {
    var dataInSession = sessionStorage.getItem("installment-calculator-".concat(postId));
    if (dataInSession && postData) {
      var _postData$g4Data, _postData$g4Data2;
      trackEvents("checkout", _objectSpread(_objectSpread({}, postData === null || postData === void 0 ? void 0 : postData.g4Data), {}, {
        booking_type: "finance",
        post_trim: postData === null || postData === void 0 ? void 0 : (_postData$g4Data = postData.g4Data) === null || _postData$g4Data === void 0 ? void 0 : _postData$g4Data.post_ext,
        from_finance_calculator: true,
        inventory_type_string: postData === null || postData === void 0 ? void 0 : (_postData$g4Data2 = postData.g4Data) === null || _postData$g4Data2 === void 0 ? void 0 : _postData$g4Data2.inventory_type_string
      }));
    }
  }, [postData]);
  useEffect(function () {
    var _postData$g4Data3, _postData$g4Data4;
    if (!postId || !(postData !== null && postData !== void 0 && postData.g4Data) || !financestep) return;
    if (hasStartedCheckoutForm) return;
    startAbandonmentTracking({
      key: "lead_abandoned_".concat(postId),
      event: "lead_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, postData.g4Data), {}, {
        inventory_type: (_postData$g4Data3 = postData.g4Data) === null || _postData$g4Data3 === void 0 ? void 0 : _postData$g4Data3.inventory_type_string,
        post_trim: (_postData$g4Data4 = postData.g4Data) === null || _postData$g4Data4 === void 0 ? void 0 : _postData$g4Data4.post_ext,
        booking_type: "finance",
        finance_type: "free",
        last_completed_step: currentStepLabel
      })
    });
  }, [currentStepLabel, financestep, hasStartedCheckoutForm, user === null || user === void 0 ? void 0 : user.id, postData, postId, startAbandonmentTracking]);
  useEffect(function () {
    var _postData$g4Data5, _postData$g4Data6;
    if (!postId || !(postData !== null && postData !== void 0 && postData.g4Data) || !financestep || !hasStartedCheckoutForm) return;
    completeAbandonmentTracking("lead_abandoned_".concat(postId));
    startAbandonmentTracking({
      key: "start_checkout_abandoned_".concat(postId),
      event: "start_checkout_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, postData.g4Data), {}, {
        inventory_type: (_postData$g4Data5 = postData.g4Data) === null || _postData$g4Data5 === void 0 ? void 0 : _postData$g4Data5.inventory_type_string,
        post_trim: (_postData$g4Data6 = postData.g4Data) === null || _postData$g4Data6 === void 0 ? void 0 : _postData$g4Data6.post_ext,
        booking_type: "finance",
        finance_type: "free",
        last_completed_step: currentStepLabel,
        from_finance_calculator: isFromFinanceCalculator
      })
    });
  }, [currentStepLabel, financestep, hasStartedCheckoutForm, isFromFinanceCalculator, completeAbandonmentTracking, user === null || user === void 0 ? void 0 : user.id, postData, postId, startAbandonmentTracking]);
  var handleCompleteLeadTracking = function handleCompleteLeadTracking() {
    completeAbandonmentTracking("lead_abandoned_".concat(postId));
    completeAbandonmentTracking("start_checkout_abandoned_".concat(postId));
  };
  var MobileHeader = function MobileHeader() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: stl.freeFinanceMobileHeaderContainer
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, !isOtpStep && /*#__PURE__*/React.createElement("span", {
      className: stl.FinanceMobileBackArrow,
      onClick: function onClick() {
        history.back();
      }
    })), /*#__PURE__*/React.createElement("strong", null, !isOtpStep && +financestep === 1 && tShort("form/personal_information"), !isOtpStep && +financestep === 2 && tShort("form/work_information"), !isOtpStep && +financestep === 3 && tShort("form/documents_required")), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("button", {
      className: [stl.backBtn].join(" "),
      style: Number(financestep) === 3 ? {
        visibility: 'hidden'
      } : {},
      disabled: loader,
      onClick: function onClick() {
        setShowPopUp(true);
      }
    }, t("cancel", {
      ns: "web_checkout_finance"
    })))), /*#__PURE__*/React.createElement("div", null, !isOtpStep && /*#__PURE__*/React.createElement(TitleSection, {
      step: +financestep
    }))));
  };
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    custommobileHeader: !reachUpload && isMobile && MobileHeader(),
    disableLoader: true,
    hideFooter: true,
    hideAppBanner: true,
    linksForSearch: true,
    mainClass: "dealersDetailed"
  }, postData && postData !== null && postData !== void 0 && (_postData$details2 = postData.details) !== null && _postData$details2 !== void 0 && _postData$details2.have_finance ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.freeFormContainer].join(" ")
  }, !isMobile && Number(financestep) !== 3 && /*#__PURE__*/React.createElement("button", {
    className: ["whtBtn", stl.backBtn].join(" "),
    disabled: loader,
    onClick: function onClick() {
      return setShowPopUp(true);
    }
  }, t("cancel", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.ColumnsContainer
  }, /*#__PURE__*/React.createElement("div", null, loader && /*#__PURE__*/React.createElement(Loader3d, null), !isMobile && !isOtpStep && /*#__PURE__*/React.createElement(TitleSection, {
    step: +financestep
  }), +financestep === 1 && /*#__PURE__*/React.createElement(InfoComponent, {
    post_id: postId,
    queryParams: queryParams,
    setIsOtpStep: setIsOtpStep,
    updateLoader: setLoader,
    setMobileNUmberForEvent: setMobileNUmberForEvent,
    onFormUpdated: setHasStartedCheckoutForm,
    onFormCompleted: handleCompleteLeadTracking,
    warrantyId: (_ref = selectedWarrantyId !== null && selectedWarrantyId !== void 0 ? selectedWarrantyId : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ === void 0 ? void 0 : (_checkoutOrder$financ2 = _checkoutOrder$financ.items) === null || _checkoutOrder$financ2 === void 0 ? void 0 : (_checkoutOrder$financ3 = _checkoutOrder$financ2.find(function (i) {
      return i.selected;
    })) === null || _checkoutOrder$financ3 === void 0 ? void 0 : _checkoutOrder$financ3.id) !== null && _ref !== void 0 ? _ref : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ4 = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ4 === void 0 ? void 0 : (_checkoutOrder$financ5 = _checkoutOrder$financ4.items) === null || _checkoutOrder$financ5 === void 0 ? void 0 : (_checkoutOrder$financ6 = _checkoutOrder$financ5[0]) === null || _checkoutOrder$financ6 === void 0 ? void 0 : _checkoutOrder$financ6.id
  }), +financestep === 2 && /*#__PURE__*/React.createElement(WorkInfoComponent, {
    post_id: postId,
    queryParams: queryParams,
    updateLoader: setLoader,
    g4Data: postData === null || postData === void 0 ? void 0 : postData.g4Data
  }), +financestep === 3 &&
  /*#__PURE__*/
  /*CHECK AMIN*/
  React.createElement(UserUploadInfo, {
    InformParentPopUpIsOpen: setReachUpload,
    mobileNUmberForEvent: mobileNUmberForEvent,
    postData: postData,
    queryParams: queryParams,
    updateLoader: setLoader
  })), /*#__PURE__*/React.createElement("div", {
    className: "md:mx-6"
  }, isMobile && isOtpStep ? /*#__PURE__*/React.createElement(React.Fragment, null) : +financestep === 3 && isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, " ") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FinanceCarCard, {
    canChangeCalculations: +financestep === 1 && !isOtpStep,
    postData: postData,
    checkoutOrder: checkoutOrder,
    setCheckoutOrder: setCheckoutOrder,
    onPeriodChange: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(period) {
        var _checkoutOrder$financ7, _checkoutOrder$financ8, _checkoutOrder$financ9;
        var currentWarrantyId, params, updated;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              currentWarrantyId = selectedWarrantyId !== null && selectedWarrantyId !== void 0 ? selectedWarrantyId : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ7 = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ7 === void 0 ? void 0 : (_checkoutOrder$financ8 = _checkoutOrder$financ7.items) === null || _checkoutOrder$financ8 === void 0 ? void 0 : (_checkoutOrder$financ9 = _checkoutOrder$financ8.find(function (i) {
                return i.selected;
              })) === null || _checkoutOrder$financ9 === void 0 ? void 0 : _checkoutOrder$financ9.id;
              params = {
                post_id: Number(postId),
                installment_period: period
              };
              if (currentWarrantyId) {
                params.warranty_id = currentWarrantyId;
              }
              _context.n = 1;
              return api__getWarrantyList(params)["catch"](function () {
                return null;
              });
            case 1:
              updated = _context.v;
              if (updated) setCheckoutOrder(function (prev) {
                return prev ? _objectSpread(_objectSpread({}, prev), updated) : updated;
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(FinanceWarrantySection, {
    canChangeWarranty: +financestep === 1 && !isOtpStep,
    checkoutOrder: checkoutOrder,
    orderType: "finance",
    referralLocation: "checkout",
    onWarrantyChange: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var _JSON$parse2, _checkoutOrder$financ0;
        var dataInSession, sessionPeriod, currentPeriod, params, updated;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              setSelectedWarrantyId(id);
              dataInSession = sessionStorage.getItem("installment-calculator-".concat(postId));
              sessionPeriod = dataInSession ? (_JSON$parse2 = JSON.parse(dataInSession)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.period : null;
              currentPeriod = sessionPeriod !== null && sessionPeriod !== void 0 ? sessionPeriod : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ0 = checkoutOrder.finance_calculator_data) === null || _checkoutOrder$financ0 === void 0 ? void 0 : _checkoutOrder$financ0.installment_period;
              params = {
                post_id: Number(postId),
                warranty_id: id
              };
              if (currentPeriod) {
                params.installment_period = currentPeriod;
              }
              _context2.n = 1;
              return api__getWarrantyList(params)["catch"](function () {
                return null;
              });
            case 1:
              updated = _context2.v;
              if (updated) setCheckoutOrder(function (prev) {
                return prev ? _objectSpread(_objectSpread({}, prev), updated) : updated;
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }())
  })))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.freeFinanceCancelOreder
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.freeFinanceCancelIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      setShowPopUp(false);
    }
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _postData$g4Data7, _postData$g4Data8;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            trackEvents(hasStartedCheckoutForm ? "start_checkout_abandoned" : "lead_abandoned", _objectSpread(_objectSpread({}, postData === null || postData === void 0 ? void 0 : postData.g4Data), {}, {
              inventory_type: postData === null || postData === void 0 ? void 0 : (_postData$g4Data7 = postData.g4Data) === null || _postData$g4Data7 === void 0 ? void 0 : _postData$g4Data7.inventory_type_string,
              post_trim: postData === null || postData === void 0 ? void 0 : (_postData$g4Data8 = postData.g4Data) === null || _postData$g4Data8 === void 0 ? void 0 : _postData$g4Data8.post_ext,
              booking_type: "finance",
              finance_type: "free",
              last_completed_step: currentStepLabel
            }, hasStartedCheckoutForm ? {
              from_finance_calculator: isFromFinanceCalculator
            } : {}));
            completeAbandonmentTracking("lead_abandoned_".concat(postId));
            completeAbandonmentTracking("start_checkout_abandoned_".concat(postId));
            if (!uuID) {
              _context3.n = 1;
              break;
            }
            setShowPopUp(false);
            setLoader(true);
            _context3.n = 1;
            return api__deleteFinanceOrder({
              order_uuid: uuID
            });
          case 1:
            navigateTo("/cardetail/".concat(postId));
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }))
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  }))))) : /*#__PURE__*/React.createElement(Loader, null));
};
export default FinanceFormPage;